import Splide from '@splidejs/splide';

const init = ( elements ) => {
	elements.forEach( ( el ) => {
		const autoplayEnabled = el.dataset.autoplay === '1';

		new Splide( el, {
			gap: 32,
			arrows: false,
			autoplay: autoplayEnabled,
			interval: 2000,
			type: 'loop',
			perPage: 6.5,
			perMove: 1,
			breakpoints: {
				768: {
					perPage: 3,
					gap: 8,
					perMove: 1,
				},
			},
		} ).mount();
	} );
};

export default init;
